// Temp fix for global not defined in older packages
window.global ||= window
